import type { IconProps } from '../types/IconProps.ts';
export const Pause: IconProps = {
    name: 'Pause',
    children: [
        `<rect width="5" height="18" x="5" y="3" rx=".5" />`,
        `<rect width="5" height="18" x="14" y="3" rx=".5" />`,
    ]
};